<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-layout
        row
        align-center
        justify-center
        v-bind="attrs"
        v-on="on"
        class="text-no-wrap font-weight-bold"
        style="width: min-content"
      >
        <v-icon
          left
          size="16"
          :color="level === 'HIGH' ? '#247058' : '#9e9e9e'"
          class="mr-1"
        >
          {{ level === "HIGH" ? "mdi-speedometer" : "mdi-speedometer-slow" }}
        </v-icon>
        <small :style="{ color: level === 'HIGH' ? '#247058' : '#9e9e9e' }">{{
          level === "HIGH" ? "Alta vazão" : "Vazão padrão"
        }}</small>
      </v-layout>
    </template>
    <span>{{
      level === "HIGH"
        ? "Max. 1000 mensagens por segundo"
        : "Max. 80 mensagens por segundo"
    }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "ThroughputChip",
  props: {
    level: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    chipColor() {
      switch (this.level) {
        case "HIGH":
          return "#4DB6AC";
        case "STANDARD":
          return "#90A4AE";
        default:
          return "#9E9E9E";
      }
    },
    chipIcon() {
      switch (this.level) {
        case "HIGH":
          return "mdi-battery-high";
        case "STANDARD":
          return "mdi-battery-low";
        default:
          return "mdi-battery-unknown";
      }
    },
    tooltipText() {
      switch (this.level) {
        case "HIGH":
          return "Max. 1000 mensagens por segundo";
        case "STANDARD":
          return "Max. 80 mensagens por segundo";
        default:
          return "Meta Throughput Level Desconhecido";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-chip__content {
  cursor: default !important;
}
</style>
